import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/AppWidget' /* webpackChunkName: "AppWidget" */)],
  Classic: () => [
    import('./viewer/AppWidget' /* webpackChunkName: "AppWidget_Classic" */),
  ],
  Responsive: () => [
    import(
      './viewer/skinComps/Responsive/Responsive.skin' /* webpackChunkName: "AppWidget_Responsive" */
    ),
  ],
  Loader: () => [
    import(
      './viewer/skinComps/Loader/Loader.skin' /* webpackChunkName: "AppWidget_Loader" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('AppWidget', UiTypes),
};

export default entry;
